import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import taxJarLogo from "../../../../assets/images/taxjar/taxjar-logotype-dark.svg";
import taxJarLightLogo from "../../../../assets/images/taxjar/taxjar-logotype.svg";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IOnUpdateSupplierIntegrationsDTO";
import ITaxJarOnUpdateNexusRegionsDTO from "../../../../models/DTO/ITaxJarOnUpdateNexusRegionsDTO";
import ITaxJarUpdateNexusRegionsDTO from "../../../../models/DTO/ITaxJarUpdateNexusRegionsDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import TaxJarViewNexusRegions from "./TaxJarViewNexusRegions/TaxJarViewNexusRegions";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    isMainViewLight: boolean;
};

type State = {
    tj_api_key: string;
    active: boolean;
    updateRegionsActive: boolean;
    modalIsOpen: boolean;
    modalComponent: any;
};

export default class TaxJarConnect extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            tj_api_key: "",
            active: false,
            updateRegionsActive: false,
            modalIsOpen: false,
            modalComponent: null,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.on(EndpointsEnum.TaxJarOnUpdateNexusRegions, this.onUpdateNexusRegions);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.removeListener(EndpointsEnum.TaxJarOnUpdateNexusRegions, this.onUpdateNexusRegions);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    notify = () => {
        let loadUser = false;

        if (this.state.active) {
            loadUser = true;
        }

        this.setState(
            {
                active: false,
            },
            () => {
                if (loadUser) {
                    this.loadUser();
                }
            }
        );
    };

    loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    toggleTaxJar = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_taxjar: !this.props.supplierModel.Supplier_Integration.has_taxjar,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    onUpdateSupplierIntegrations = (data: IOnUpdateSupplierIntegrationsDTO) => {
        this.setState({
            active: false,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    saveChanges = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                tj_api_key: this.state.tj_api_key,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            active: true,
        });
    };

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    viewNexus = () => {
        const modalComponent = (
            <TaxJarViewNexusRegions
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    syncNexus = () => {
        const payload: ITaxJarUpdateNexusRegionsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TaxJarUpdateNexusRegions, payload);

        this.setState({
            updateRegionsActive: true,
        });
    };

    onUpdateNexusRegions = (data: ITaxJarOnUpdateNexusRegionsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_taxjar_nexus_regions",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            updateRegionsActive: false,
        });
    };

    render() {
        let logo = taxJarLogo;

        if (this.props.isMainViewLight) {
            logo = taxJarLightLogo;
        }

        const hasTaxJar = !!this.props.supplierModel.Supplier_Integration.has_taxjar;

        const hasSavedToken = this.props.supplierModel.Supplier_Integration.tj_api_key === "true";

        return (
            <div className={"TaxJarConnect"}>
                <OwAccordion
                    hideChevron={!hasTaxJar}
                    leftImage={logo}
                    leftImageHeight={30}
                    leftImageAlt={"Tax Jar"}
                    titleClick={true}
                    rightElem={
                        <div className={"ms-auto"}>
                            <OwToggle fn={this.toggleTaxJar} name={"has_taxjar"} label={""} active={hasTaxJar} />
                        </div>
                    }>
                    <div className={"d-flex flex-column w-15r"}>
                        {hasTaxJar ? (
                            <div>
                                <div>
                                    <OwLabel title={"api_token"} />
                                    <OwInputWrapper fn={this.handleChange} name={"tj_api_key"} value={this.state.tj_api_key} />
                                    {hasSavedToken ? (
                                        <OwLabel className={"text-success"} title={"has_token_set"} leftIconClass={"fas fa-check"} />
                                    ) : (
                                        <OwLabel className={"text-danger"} title={"no_token_set"} leftIconClass={"fas fa-times"} />
                                    )}
                                </div>
                                <div className={"mt-2"}>
                                    <OwButton title={"save"} fn={this.saveChanges} active={this.state.active} disableOnActive={true} />
                                </div>
                                <div className={"mt-2"}>
                                    <OwButton
                                        title={"sync_nexus_regions"}
                                        fn={this.syncNexus}
                                        active={this.state.active}
                                        disableOnActive={true}
                                    />
                                </div>
                                <div className={"mt-2"}>
                                    <OwButton title={"view_nexus_regions"} fn={this.viewNexus} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </OwAccordion>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}
                        style={{}}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}
